<form (submit)="setSolrDate()">
  <input type="text"
         placeholder="{{'TRANS__LOCAL_DATE_FORMAT' | translate}}"
         [(ngModel)]='localDate'
         (ngModelChange)="onChange($event)"
         [ngModelOptions]="{standalone: true}"
         [ngClass]="{'errorInputFrame': !valid}">
</form>
